import { css } from 'styled-components';

export const cssFloatRight = css`
  float: right;
`;

export const cssFloatLeft = css`
  float: left;
`;

export const cssClearFix = css`
  &::after {
    content: '';
    clear: both;
    display: block;
  }
`;

export const bottonCommon = css`
  font-size: 13px;
  padding-top: 4px;
  padding-bottom: 5px;
  font-weight: 400;
  background: #ffffff;
  color: #2f3133;
  border-radius: 2px;
  border: 1px solid#b1b6bb;
  min-width: 96px;
  text-align: center;
  box-sizing: border-box;
  padding-left: 0px;
  padding-right: 0px;

  &:hover {
    //background: #747474;
    cursor: pointer;
  }

  ${(props) =>
    props.block &&
    css`
      cursor: not-allowed;
    `};
`;

export const noTextSelect = css`
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                        supported by Chrome, Edge, Opera and Firefox */
`;

export const CustomScrollbar = css`
  /* &::-webkit-scrollbar { display: none; }
  scrollbar-width: none; */
  scrollbar-color: #ebebeb #ffffff;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
    background: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #ebebeb;

    &:hover {
      background-color: #adb5bd;
    }
  }
  &::-webkit-scrollbar-track {
    background: #ffffff;
  }
`;
